const getOpacityFromForegroundColor = (foregroundColor?: string) => {
    return foregroundColor === 'black' ? 'subtle' : 'overlay';
};

export default getOpacityFromForegroundColor;
